// This file is auto-generated by @hey-api/openapi-ts

import { type Client, formDataBodySerializer, type Options as Options2, type TDataShape } from './client';
import { client } from './client.gen';
import type { DeleteAssignmentsByAssignmentIdData, DeleteAssignmentsByAssignmentIdErrors, DeleteAssignmentsByAssignmentIdResponses, DeleteNotesByNoteIdData, DeleteNotesByNoteIdErrors, DeleteNotesByNoteIdResponses, DeleteStudyNotebooksByIdData, DeleteStudyNotebooksByIdDocumentsByDocIdData, DeleteStudyNotebooksByIdDocumentsByDocIdResponses, DeleteStudyNotebooksByIdErrors, DeleteStudyNotebooksByIdHighlightsByHighlightIdData, DeleteStudyNotebooksByIdHighlightsByHighlightIdResponses, DeleteStudyNotebooksByIdResponses, GetAssignmentsWeeklyUsageData, GetAssignmentsWeeklyUsageResponses, GetInsightsAggregateData, GetInsightsCourseData, GetInsightsIndividualData, GetInsightsOptInData, GetInsightsWrappedData, GetNotesCheckStorageUsageData, GetNotesCheckStorageUsageResponses, GetPaymentData, GetStudyDocumentsLimitsData, GetStudyDocumentsLimitsResponses, GetStudyDocumentsMaxFileSizeData, GetStudyDocumentsMaxFileSizeResponses, GetStudyDocumentsSupportedTypesData, GetStudyDocumentsSupportedTypesResponses, GetStudyNotebooksByIdDocumentsData, GetStudyNotebooksByIdDocumentsResponses, GetStudyNotebooksByIdHighlightsByHighlightIdData, GetStudyNotebooksByIdHighlightsByHighlightIdResponses, GetStudyNotebooksByIdHighlightsData, GetStudyNotebooksByIdHighlightsResponses, GetStudyNotebooksByNotebookIdChatsByChatIdData, GetStudyNotebooksByNotebookIdChatsByChatIdResponses, GetStudyNotebooksByNotebookIdChatsData, GetStudyNotebooksByNotebookIdChatsResponses, GetStudyNotebooksByNotebookIdDocumentsByDocumentIdChunksByChunkIdData, GetStudyNotebooksByNotebookIdDocumentsByDocumentIdChunksByChunkIdErrors, GetStudyNotebooksByNotebookIdDocumentsByDocumentIdChunksByChunkIdResponses, GetStudyNotebooksByNotebookIdDocumentsByNotebookDocumentIdFileData, GetStudyNotebooksByNotebookIdDocumentsByNotebookDocumentIdFileResponses, GetStudyNotebooksData, GetStudyNotebooksResponses, GetThemesCheckLimitsData, GetThemesCheckSwapLimitData, GetThemesCodeData, GetThemesCommentsData, GetThemesData, GetThemesHistoryData, GetThemesHomeData, GetThemesTrendingData, GetThemesUserThemesData, GetUnsubscribeData, GetUnsubscribeErrors, GetUnsubscribeResponses, GetUsersBillingInfoData, GetUsersBillingInfoErrors, GetUsersBillingInfoResponses, GetUsersCheckSignupCompletionData, GetUsersGetStripePricesData, GetUsersGetStripePricesErrors, GetUsersGetStripePricesResponses, GetUsersSubscriptionStatusData, PostAssignmentsUpsertData, PostBetaChangeHasClaimedTrialData, PostBetaChangePlanDatesData, PostBetaChangePlanTypeData, PostBetaDeleteAllUserDataData, PostBetaRemoveStripeCustomerData, PostBetaUpdateUsageData, PostGoogleCalData, PostGoogleCalRefreshData, PostGoogleCalRefreshResponses, PostGoogleCalResponses, PostInsightsOptInData, PostInsightsUpdateData, PostNotesApplyDeltasData, PostNotesApplyDeltasErrors, PostNotesApplyDeltasResponses, PostNotesCombineDeltasData, PostNotesCombineDeltasErrors, PostNotesCombineDeltasResponses, PostNotesCreateNoteData, PostNotesCreateNoteErrors, PostNotesCreateNoteResponses, PostNotesCreateSlateNoteData, PostNotesCreateSlateNoteErrors, PostNotesCreateSlateNoteResponses, PostNotesLoadNoteData, PostNotesLoadNoteResponses, PostNotesLoadWithDeltasData, PostNotesLoadWithDeltasErrors, PostNotesLoadWithDeltasResponses, PostNotesPushDeltaData, PostNotesPushDeltaErrors, PostNotesPushDeltaResponses, PostNotesSmartNoteData, PostNotesSmartNoteErrors, PostNotesSmartNoteResponses, PostNotesSyncNoteData, PostNotesSyncNoteErrors, PostNotesSyncNoteResponses, PostNotesUpdateNoteData, PostNotesUpdateNoteErrors, PostNotesUpdateNoteResponses, PostStripeWebhookData, PostStudyFileNotebooksData, PostStudyFileNotebooksResponses, PostStudyNotebooksByIdDocumentsData, PostStudyNotebooksByIdDocumentsErrors, PostStudyNotebooksByIdDocumentsResponses, PostStudyNotebooksByIdHighlightsData, PostStudyNotebooksByIdHighlightsErrors, PostStudyNotebooksByIdHighlightsResponses, PostStudyNotebooksByNotebookIdChatByChatIdMessageData, PostStudyNotebooksByNotebookIdChatByChatIdMessageResponses, PostStudyNotebooksByNotebookIdChatsData, PostStudyNotebooksByNotebookIdChatsResponses, PostStudyNotebooksData, PostStudyNotebooksErrors, PostStudyNotebooksResponses, PostSupabaseWebhookData, PostThemesApplyData, PostThemesAutoRotateData, PostThemesCommentsData, PostThemesEditData, PostThemesLikeData, PostThemesSubmitData, PostThemesUnpublishData, PostTranscribeData, PostTranscribeErrors, PostTranscribeResponses, PostTrialClaimData, PostUsersCreateStripeCheckoutData, PostUsersCreateStripeCheckoutErrors, PostUsersCreateStripeCheckoutResponses, PostUsersVerifyAgeData, PutStudyNotebooksByIdData, PutStudyNotebooksByIdDocumentsByDocIdData, PutStudyNotebooksByIdDocumentsByDocIdResponses, PutStudyNotebooksByIdErrors, PutStudyNotebooksByIdHighlightsByHighlightIdData, PutStudyNotebooksByIdHighlightsByHighlightIdResponses, PutStudyNotebooksByIdResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Updates or inserts a list of planned assignments
 */
export const postAssignmentsUpsert = <ThrowOnError extends boolean = false>(options?: Options<PostAssignmentsUpsertData, ThrowOnError>) => (options?.client ?? client).post<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/assignments/upsert',
    ...options
});

/**
 * Gets the current weekly planned assignments usage for the authenticated user
 */
export const getAssignmentsWeeklyUsage = <ThrowOnError extends boolean = false>(options?: Options<GetAssignmentsWeeklyUsageData, ThrowOnError>) => (options?.client ?? client).get<GetAssignmentsWeeklyUsageResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/assignments/weekly-usage',
    ...options
});

/**
 * Deletes a planned assignment and decrements weekly usage if it was planned this week
 */
export const deleteAssignmentsByAssignmentId = <ThrowOnError extends boolean = false>(options?: Options<DeleteAssignmentsByAssignmentIdData, ThrowOnError>) => (options?.client ?? client).delete<DeleteAssignmentsByAssignmentIdResponses, DeleteAssignmentsByAssignmentIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/assignments/{assignmentId}',
    ...options
});

/**
 * Updates or inserts a list of planned assignments
 */
export const postThemesEdit = <ThrowOnError extends boolean = false>(options?: Options<PostThemesEditData, ThrowOnError>) => (options?.client ?? client).post<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/themes/edit',
    ...options
});

/**
 * Checks if the user has reached their theme swap limit
 */
export const getThemesCheckSwapLimit = <ThrowOnError extends boolean = false>(options?: Options<GetThemesCheckSwapLimitData, ThrowOnError>) => (options?.client ?? client).get<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/themes/check-swap-limit',
    ...options
});

/**
 * Checks if the user has reached their theme limits
 */
export const getThemesCheckLimits = <ThrowOnError extends boolean = false>(options?: Options<GetThemesCheckLimitsData, ThrowOnError>) => (options?.client ?? client).get<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/themes/check-limits',
    ...options
});

/**
 * Confirms a theme swap
 */
export const postThemesApply = <ThrowOnError extends boolean = false>(options?: Options<PostThemesApplyData, ThrowOnError>) => (options?.client ?? client).post<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/themes/apply',
    ...options
});

/**
 * Selects a random theme based on theme_source and selections. Supports 'community' (new, trending) and 'mine' (created, remixed, liked) sources.
 */
export const postThemesAutoRotate = <ThrowOnError extends boolean = false>(options?: Options<PostThemesAutoRotateData, ThrowOnError>) => (options?.client ?? client).post<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/themes/auto-rotate',
    ...options
});

/**
 * Gets theme history for the authenticated user. Free users get 2 most recent swaps, premium users get 10 most recent swaps.
 */
export const getThemesHistory = <ThrowOnError extends boolean = false>(options?: Options<GetThemesHistoryData, ThrowOnError>) => (options?.client ?? client).get<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/themes/history',
    ...options
});

/**
 * Gets aggregated themes home data with all sections (popular, newest, trending, lebron, anime, pastel). Works for both authenticated and anonymous users.
 */
export const getThemesHome = <ThrowOnError extends boolean = false>(options?: Options<GetThemesHomeData, ThrowOnError>) => (options?.client ?? client).get<unknown, unknown, ThrowOnError>({ url: '/themes/home', ...options });

/**
 * Gets trending themes for the last 24 hours
 */
export const getThemesTrending = <ThrowOnError extends boolean = false>(options?: Options<GetThemesTrendingData, ThrowOnError>) => (options?.client ?? client).get<unknown, unknown, ThrowOnError>({ url: '/themes/trending', ...options });

/**
 * Toggle like on a theme. Returns true if liked, false if unliked. Migrated from backend-v3 RPC: toggle_theme_like
 */
export const postThemesLike = <ThrowOnError extends boolean = false>(options?: Options<PostThemesLikeData, ThrowOnError>) => (options?.client ?? client).post<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/themes/like',
    ...options
});

/**
 * Get paginated comments for a theme. Migrated from backend-v3 RPC: get_theme_comments_paginated
 */
export const getThemesComments = <ThrowOnError extends boolean = false>(options?: Options<GetThemesCommentsData, ThrowOnError>) => (options?.client ?? client).get<unknown, unknown, ThrowOnError>({ url: '/themes/comments', ...options });

/**
 * Add a comment to a theme. Returns the comment ID. Migrated from backend-v3 RPC: add_theme_comment
 */
export const postThemesComments = <ThrowOnError extends boolean = false>(options?: Options<PostThemesCommentsData, ThrowOnError>) => (options?.client ?? client).post<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/themes/comments',
    ...options
});

/**
 * Submit theme for approval. Validates theme and checks similarity. Migrated from backend-v3 Edge Function: theme-submit
 */
export const postThemesSubmit = <ThrowOnError extends boolean = false>(options?: Options<PostThemesSubmitData, ThrowOnError>) => (options?.client ?? client).post<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/themes/submit',
    ...options
});

/**
 * Unpublish a theme (set to private). Migrated from backend-v3 Edge Function: theme-unpublish
 */
export const postThemesUnpublish = <ThrowOnError extends boolean = false>(options?: Options<PostThemesUnpublishData, ThrowOnError>) => (options?.client ?? client).post<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/themes/unpublish',
    ...options
});

/**
 * Gets approved themes with filtering, sorting, and pagination. Supports sort (score, alphabetical, newest, trending), category filtering, and search. Migrated from backend-v3 RPC. Works for both authenticated and anonymous users. Includes 10-minute caching.
 */
export const getThemes = <ThrowOnError extends boolean = false>(options?: Options<GetThemesData, ThrowOnError>) => (options?.client ?? client).get<unknown, unknown, ThrowOnError>({ url: '/themes', ...options });

/**
 * Gets authenticated user's themes filtered by origin type (original, community, etc.). Supports pagination and search. Migrated from backend-v3 RPC.
 */
export const getThemesUserThemes = <ThrowOnError extends boolean = false>(options?: Options<GetThemesUserThemesData, ThrowOnError>) => (options?.client ?? client).get<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/themes/user-themes',
    ...options
});

/**
 * Gets a single theme by code with 24-hour cache. Optional query param 'includeComments=true' will include the first 6 comments. Replaces direct PostgREST calls.
 */
export const getThemesCode = <ThrowOnError extends boolean = false>(options?: Options<GetThemesCodeData, ThrowOnError>) => (options?.client ?? client).get<unknown, unknown, ThrowOnError>({ url: '/themes/:code', ...options });

/**
 * Retrieve all chats for the authenticated user
 */
export const getStudyNotebooksByNotebookIdChats = <ThrowOnError extends boolean = false>(options: Options<GetStudyNotebooksByNotebookIdChatsData, ThrowOnError>) => (options.client ?? client).get<GetStudyNotebooksByNotebookIdChatsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/study/notebooks/{notebook_id}/chats',
    ...options
});

/**
 * Create a new chat session
 */
export const postStudyNotebooksByNotebookIdChats = <ThrowOnError extends boolean = false>(options: Options<PostStudyNotebooksByNotebookIdChatsData, ThrowOnError>) => (options.client ?? client).post<PostStudyNotebooksByNotebookIdChatsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/study/notebooks/{notebook_id}/chats',
    ...options
});

/**
 * Retrieve a specific chat with full message history
 */
export const getStudyNotebooksByNotebookIdChatsByChatId = <ThrowOnError extends boolean = false>(options: Options<GetStudyNotebooksByNotebookIdChatsByChatIdData, ThrowOnError>) => (options.client ?? client).get<GetStudyNotebooksByNotebookIdChatsByChatIdResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/study/notebooks/{notebook_id}/chats/{chat_id}',
    ...options
});

/**
 * Send a message to a chat and get a response. Supports streaming via the `stream` query parameter.
 */
export const postStudyNotebooksByNotebookIdChatByChatIdMessage = <ThrowOnError extends boolean = false>(options: Options<PostStudyNotebooksByNotebookIdChatByChatIdMessageData, ThrowOnError>) => (options.client ?? client).sse.post<PostStudyNotebooksByNotebookIdChatByChatIdMessageResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/study/notebooks/{notebook_id}/chat/{chat_id}/message',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Retrieve all notebooks for the authenticated user
 */
export const getStudyNotebooks = <ThrowOnError extends boolean = false>(options?: Options<GetStudyNotebooksData, ThrowOnError>) => (options?.client ?? client).get<GetStudyNotebooksResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/study/notebooks',
    ...options
});

/**
 * Create a new notebook for organizing documents and highlights
 */
export const postStudyNotebooks = <ThrowOnError extends boolean = false>(options?: Options<PostStudyNotebooksData, ThrowOnError>) => (options?.client ?? client).post<PostStudyNotebooksResponses, PostStudyNotebooksErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/study/notebooks',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Delete a notebook and all associated data
 */
export const deleteStudyNotebooksById = <ThrowOnError extends boolean = false>(options: Options<DeleteStudyNotebooksByIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteStudyNotebooksByIdResponses, DeleteStudyNotebooksByIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/study/notebooks/{id}',
    ...options
});

/**
 * Update an existing notebook.
 */
export const putStudyNotebooksById = <ThrowOnError extends boolean = false>(options: Options<PutStudyNotebooksByIdData, ThrowOnError>) => (options.client ?? client).put<PutStudyNotebooksByIdResponses, PutStudyNotebooksByIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/study/notebooks/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Retrieve all file notebooks for the authenticated user
 */
export const postStudyFileNotebooks = <ThrowOnError extends boolean = false>(options?: Options<PostStudyFileNotebooksData, ThrowOnError>) => (options?.client ?? client).post<PostStudyFileNotebooksResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/study/file_notebooks',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Retrieve all documents associated with a specific notebook
 */
export const getStudyNotebooksByIdDocuments = <ThrowOnError extends boolean = false>(options: Options<GetStudyNotebooksByIdDocumentsData, ThrowOnError>) => (options.client ?? client).get<GetStudyNotebooksByIdDocumentsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/study/notebooks/{id}/documents',
    ...options
});

/**
 * Upload a new document and add it to a notebook with metadata. The file is automatically processed server-side.
 */
export const postStudyNotebooksByIdDocuments = <ThrowOnError extends boolean = false>(options: Options<PostStudyNotebooksByIdDocumentsData, ThrowOnError>) => (options.client ?? client).post<PostStudyNotebooksByIdDocumentsResponses, PostStudyNotebooksByIdDocumentsErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/study/notebooks/{id}/documents',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Delete a document and remove it from a notebook
 */
export const deleteStudyNotebooksByIdDocumentsByDocId = <ThrowOnError extends boolean = false>(options: Options<DeleteStudyNotebooksByIdDocumentsByDocIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteStudyNotebooksByIdDocumentsByDocIdResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/study/notebooks/{id}/documents/{doc_id}',
    ...options
});

/**
 * Update a document's metadata, including name, visibility, and custom metadata
 */
export const putStudyNotebooksByIdDocumentsByDocId = <ThrowOnError extends boolean = false>(options: Options<PutStudyNotebooksByIdDocumentsByDocIdData, ThrowOnError>) => (options.client ?? client).put<PutStudyNotebooksByIdDocumentsByDocIdResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/study/notebooks/{id}/documents/{doc_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Retrieve a specific chunk of a document associated with a specific notebook
 */
export const getStudyNotebooksByNotebookIdDocumentsByDocumentIdChunksByChunkId = <ThrowOnError extends boolean = false>(options: Options<GetStudyNotebooksByNotebookIdDocumentsByDocumentIdChunksByChunkIdData, ThrowOnError>) => (options.client ?? client).get<GetStudyNotebooksByNotebookIdDocumentsByDocumentIdChunksByChunkIdResponses, GetStudyNotebooksByNotebookIdDocumentsByDocumentIdChunksByChunkIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/study/notebooks/{notebook_id}/documents/{document_id}/chunks/{chunk_id}',
    ...options
});

/**
 * Retrieve the list of supported file types for notebook document uploads
 */
export const getStudyDocumentsSupportedTypes = <ThrowOnError extends boolean = false>(options?: Options<GetStudyDocumentsSupportedTypesData, ThrowOnError>) => (options?.client ?? client).get<GetStudyDocumentsSupportedTypesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/study/documents/supported-types',
    ...options
});

/**
 * Retrieve the mapping of max file sizes for notebook document uploads based on user plan type.
 */
export const getStudyDocumentsMaxFileSize = <ThrowOnError extends boolean = false>(options?: Options<GetStudyDocumentsMaxFileSizeData, ThrowOnError>) => (options?.client ?? client).get<GetStudyDocumentsMaxFileSizeResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/study/documents/max-file-size',
    ...options
});

/**
 * Retrieve all document upload limits for the current user, including supported file types and max file size by plan.
 */
export const getStudyDocumentsLimits = <ThrowOnError extends boolean = false>(options?: Options<GetStudyDocumentsLimitsData, ThrowOnError>) => (options?.client ?? client).get<GetStudyDocumentsLimitsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/study/documents/limits',
    ...options
});

/**
 * Get a presigned URL to download the original file content of a notebook document
 */
export const getStudyNotebooksByNotebookIdDocumentsByNotebookDocumentIdFile = <ThrowOnError extends boolean = false>(options: Options<GetStudyNotebooksByNotebookIdDocumentsByNotebookDocumentIdFileData, ThrowOnError>) => (options.client ?? client).get<GetStudyNotebooksByNotebookIdDocumentsByNotebookDocumentIdFileResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/study/notebooks/{notebook_id}/documents/{notebook_document_id}/file',
    ...options
});

/**
 * Retrieve all highlights in a notebook (excludes large content field)
 */
export const getStudyNotebooksByIdHighlights = <ThrowOnError extends boolean = false>(options: Options<GetStudyNotebooksByIdHighlightsData, ThrowOnError>) => (options.client ?? client).get<GetStudyNotebooksByIdHighlightsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/study/notebooks/{id}/highlights',
    ...options
});

/**
 * Create a new highlight in a notebook
 */
export const postStudyNotebooksByIdHighlights = <ThrowOnError extends boolean = false>(options: Options<PostStudyNotebooksByIdHighlightsData, ThrowOnError>) => (options.client ?? client).post<PostStudyNotebooksByIdHighlightsResponses, PostStudyNotebooksByIdHighlightsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/study/notebooks/{id}/highlights',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a highlight from a notebook
 */
export const deleteStudyNotebooksByIdHighlightsByHighlightId = <ThrowOnError extends boolean = false>(options: Options<DeleteStudyNotebooksByIdHighlightsByHighlightIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteStudyNotebooksByIdHighlightsByHighlightIdResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/study/notebooks/{id}/highlights/{highlight_id}',
    ...options
});

/**
 * Retrieve a single highlight with its full contents
 */
export const getStudyNotebooksByIdHighlightsByHighlightId = <ThrowOnError extends boolean = false>(options: Options<GetStudyNotebooksByIdHighlightsByHighlightIdData, ThrowOnError>) => (options.client ?? client).get<GetStudyNotebooksByIdHighlightsByHighlightIdResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/study/notebooks/{id}/highlights/{highlight_id}',
    ...options
});

/**
 * Update a highlight's name, contents, and metadata
 */
export const putStudyNotebooksByIdHighlightsByHighlightId = <ThrowOnError extends boolean = false>(options: Options<PutStudyNotebooksByIdHighlightsByHighlightIdData, ThrowOnError>) => (options.client ?? client).put<PutStudyNotebooksByIdHighlightsByHighlightIdResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/study/notebooks/{id}/highlights/{highlight_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Claims the trial for the current user. Creates a Stripe customer and sets trial end date to 7 days from now.
 */
export const postTrialClaim = <ThrowOnError extends boolean = false>(options?: Options<PostTrialClaimData, ThrowOnError>) => (options?.client ?? client).post<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/trial/claim',
    ...options
});

/**
 * Transcribe an audio file using Groq API. Supports both note and file transcriptions.
 */
export const postTranscribe = <ThrowOnError extends boolean = false>(options?: Options<PostTranscribeData, ThrowOnError>) => (options?.client ?? client).post<PostTranscribeResponses, PostTranscribeErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transcribe',
    ...options,
    headers: {
        'Content-Type': null,
        ...options?.headers
    }
});

/**
 * Checks the current indefinite note storage MB usage and returns the limit for the user's plan.
 */
export const getNotesCheckStorageUsage = <ThrowOnError extends boolean = false>(options?: Options<GetNotesCheckStorageUsageData, ThrowOnError>) => (options?.client ?? client).get<GetNotesCheckStorageUsageResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/notes/check-storage-usage',
    ...options
});

/**
 * Creates a new note with proper Slate.js structure. Checks and increments note storage usage limits.
 */
export const postNotesCreateSlateNote = <ThrowOnError extends boolean = false>(options?: Options<PostNotesCreateSlateNoteData, ThrowOnError>) => (options?.client ?? client).post<PostNotesCreateSlateNoteResponses, PostNotesCreateSlateNoteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/notes/create-slate-note',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Push delta operations to the queue for later application
 */
export const postNotesPushDelta = <ThrowOnError extends boolean = false>(options?: Options<PostNotesPushDeltaData, ThrowOnError>) => (options?.client ?? client).post<PostNotesPushDeltaResponses, PostNotesPushDeltaErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/notes/push-delta',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Sync note by applying operations directly to content
 */
export const postNotesSyncNote = <ThrowOnError extends boolean = false>(options?: Options<PostNotesSyncNoteData, ThrowOnError>) => (options?.client ?? client).post<PostNotesSyncNoteResponses, PostNotesSyncNoteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/notes/sync-note',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Apply pending delta operations to a note
 */
export const postNotesApplyDeltas = <ThrowOnError extends boolean = false>(options?: Options<PostNotesApplyDeltasData, ThrowOnError>) => (options?.client ?? client).post<PostNotesApplyDeltasResponses, PostNotesApplyDeltasErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/notes/apply-deltas',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Load note content with pending deltas applied
 */
export const postNotesLoadWithDeltas = <ThrowOnError extends boolean = false>(options?: Options<PostNotesLoadWithDeltasData, ThrowOnError>) => (options?.client ?? client).post<PostNotesLoadWithDeltasResponses, PostNotesLoadWithDeltasErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/notes/load-with-deltas',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Combine pending deltas in the background
 */
export const postNotesCombineDeltas = <ThrowOnError extends boolean = false>(options?: Options<PostNotesCombineDeltasData, ThrowOnError>) => (options?.client ?? client).post<PostNotesCombineDeltasResponses, PostNotesCombineDeltasErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/notes/combine-deltas',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Generate smart note using AI to improve note content
 */
export const postNotesSmartNote = <ThrowOnError extends boolean = false>(options?: Options<PostNotesSmartNoteData, ThrowOnError>) => (options?.client ?? client).sse.post<PostNotesSmartNoteResponses, PostNotesSmartNoteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/notes/smart-note',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Deletes a note and its associated data
 */
export const deleteNotesByNoteId = <ThrowOnError extends boolean = false>(options?: Options<DeleteNotesByNoteIdData, ThrowOnError>) => (options?.client ?? client).delete<DeleteNotesByNoteIdResponses, DeleteNotesByNoteIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/notes/{noteId}',
    ...options
});

/**
 * Creates a new note
 */
export const postNotesCreateNote = <ThrowOnError extends boolean = false>(options?: Options<PostNotesCreateNoteData, ThrowOnError>) => (options?.client ?? client).post<PostNotesCreateNoteResponses, PostNotesCreateNoteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/notes/create-note',
    ...options
});

/**
 * Updates a note
 */
export const postNotesUpdateNote = <ThrowOnError extends boolean = false>(options?: Options<PostNotesUpdateNoteData, ThrowOnError>) => (options?.client ?? client).post<PostNotesUpdateNoteResponses, PostNotesUpdateNoteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/notes/update-note',
    ...options
});

/**
 * Loads a note
 */
export const postNotesLoadNote = <ThrowOnError extends boolean = false>(options?: Options<PostNotesLoadNoteData, ThrowOnError>) => (options?.client ?? client).post<PostNotesLoadNoteResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/notes/load-note',
    ...options
});

/**
 * Get the subscription status for the current authenticated user.
 */
export const getUsersSubscriptionStatus = <ThrowOnError extends boolean = false>(options?: Options<GetUsersSubscriptionStatusData, ThrowOnError>) => (options?.client ?? client).get<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/subscription-status',
    ...options
});

/**
 * Check if the user has completed the signup flow by verifying subscription_state exists.
 */
export const getUsersCheckSignupCompletion = <ThrowOnError extends boolean = false>(options?: Options<GetUsersCheckSignupCompletionData, ThrowOnError>) => (options?.client ?? client).get<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/check-signup-completion',
    ...options
});

/**
 * Verify the user's age and set the age band.
 */
export const postUsersVerifyAge = <ThrowOnError extends boolean = false>(options?: Options<PostUsersVerifyAgeData, ThrowOnError>) => (options?.client ?? client).post<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/verify-age',
    ...options
});

/**
 * Create a Stripe checkout session for a given price ID.
 */
export const postUsersCreateStripeCheckout = <ThrowOnError extends boolean = false>(options?: Options<PostUsersCreateStripeCheckoutData, ThrowOnError>) => (options?.client ?? client).post<PostUsersCreateStripeCheckoutResponses, PostUsersCreateStripeCheckoutErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/create-stripe-checkout',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Get detailed billing information including amount, interval, and next billing date from Stripe.
 */
export const getUsersBillingInfo = <ThrowOnError extends boolean = false>(options?: Options<GetUsersBillingInfoData, ThrowOnError>) => (options?.client ?? client).get<GetUsersBillingInfoResponses, GetUsersBillingInfoErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/billing-info',
    ...options
});

/**
 * Get Stripe price information for all available plans (style_monthly, style_annually, learn_monthly, learn_annually).
 */
export const getUsersGetStripePrices = <ThrowOnError extends boolean = false>(options?: Options<GetUsersGetStripePricesData, ThrowOnError>) => (options?.client ?? client).get<GetUsersGetStripePricesResponses, GetUsersGetStripePricesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/get-stripe-prices',
    ...options
});

/**
 * Handle payment link clicks from emails. Validates token, logs click, and redirects to Stripe checkout.
 */
export const getPayment = <ThrowOnError extends boolean = false>(options: Options<GetPaymentData, ThrowOnError>) => (options.client ?? client).get<unknown, unknown, ThrowOnError>({ url: '/payment', ...options });

/**
 * Exchange Google OAuth authorization code for access and refresh tokens.
 */
export const postGoogleCal = <ThrowOnError extends boolean = false>(options?: Options<PostGoogleCalData, ThrowOnError>) => (options?.client ?? client).post<PostGoogleCalResponses, unknown, ThrowOnError>({
    url: '/google-cal',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Refresh Google OAuth access token using refresh token.
 */
export const postGoogleCalRefresh = <ThrowOnError extends boolean = false>(options?: Options<PostGoogleCalRefreshData, ThrowOnError>) => (options?.client ?? client).post<PostGoogleCalRefreshResponses, unknown, ThrowOnError>({
    url: '/google-cal-refresh',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Updates or inserts a list of planned assignments
 */
export const postStripeWebhook = <ThrowOnError extends boolean = false>(options?: Options<PostStripeWebhookData, ThrowOnError>) => (options?.client ?? client).post<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/stripe/webhook',
    ...options
});

/**
 * Handles the Supabase webhook.
 */
export const postSupabaseWebhook = <ThrowOnError extends boolean = false>(options?: Options<PostSupabaseWebhookData, ThrowOnError>) => (options?.client ?? client).post<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/supabase/webhook',
    ...options
});

/**
 * Unsubscribe from email list
 *
 * Unsubscribe an email address from marketing emails using HMAC token
 */
export const getUnsubscribe = <ThrowOnError extends boolean = false>(options: Options<GetUnsubscribeData, ThrowOnError>) => (options.client ?? client).get<GetUnsubscribeResponses, GetUnsubscribeErrors, ThrowOnError>({ url: '/unsubscribe', ...options });

/**
 * Updates aggregate insights for the user
 */
export const postInsightsUpdate = <ThrowOnError extends boolean = false>(options?: Options<PostInsightsUpdateData, ThrowOnError>) => (options?.client ?? client).post<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/insights/update',
    ...options
});

/**
 * Queries aggregate insights for the user
 */
export const getInsightsAggregate = <ThrowOnError extends boolean = false>(options: Options<GetInsightsAggregateData, ThrowOnError>) => (options.client ?? client).get<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/insights/aggregate',
    ...options
});

/**
 * Queries individual insights for the user
 */
export const getInsightsIndividual = <ThrowOnError extends boolean = false>(options: Options<GetInsightsIndividualData, ThrowOnError>) => (options.client ?? client).get<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/insights/individual',
    ...options
});

/**
 * Queries course insights for the user
 */
export const getInsightsCourse = <ThrowOnError extends boolean = false>(options: Options<GetInsightsCourseData, ThrowOnError>) => (options.client ?? client).get<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/insights/course',
    ...options
});

/**
 * Queries the user's wrapped stats
 */
export const getInsightsWrapped = <ThrowOnError extends boolean = false>(options: Options<GetInsightsWrappedData, ThrowOnError>) => (options.client ?? client).get<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/insights/wrapped',
    ...options
});

/**
 * Queries opt-in status for the user
 */
export const getInsightsOptIn = <ThrowOnError extends boolean = false>(options?: Options<GetInsightsOptInData, ThrowOnError>) => (options?.client ?? client).get<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/insights/opt-in',
    ...options
});

/**
 * Updates opt-in status for the user
 */
export const postInsightsOptIn = <ThrowOnError extends boolean = false>(options?: Options<PostInsightsOptInData, ThrowOnError>) => (options?.client ?? client).post<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/insights/opt-in',
    ...options
});

/**
 * Changes the plan dates for the user
 */
export const postBetaChangePlanDates = <ThrowOnError extends boolean = false>(options?: Options<PostBetaChangePlanDatesData, ThrowOnError>) => (options?.client ?? client).post<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/beta/change-plan-dates',
    ...options
});

/**
 * Completely removes a customer from Stripe and resets their subscription to free plan
 */
export const postBetaRemoveStripeCustomer = <ThrowOnError extends boolean = false>(options?: Options<PostBetaRemoveStripeCustomerData, ThrowOnError>) => (options?.client ?? client).post<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/beta/remove-stripe-customer',
    ...options
});

/**
 * Completely deletes all user data from the database and removes the user from auth. This is irreversible.
 */
export const postBetaDeleteAllUserData = <ThrowOnError extends boolean = false>(options?: Options<PostBetaDeleteAllUserDataData, ThrowOnError>) => (options?.client ?? client).post<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/beta/delete-all-user-data',
    ...options
});

/**
 * Changes the has claimed trial flag for the user
 */
export const postBetaChangeHasClaimedTrial = <ThrowOnError extends boolean = false>(options?: Options<PostBetaChangeHasClaimedTrialData, ThrowOnError>) => (options?.client ?? client).post<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/beta/change-has-claimed-trial',
    ...options
});

/**
 * Updates or creates a plan usage limit record. If the record doesn't exist, it will be created.
 */
export const postBetaUpdateUsage = <ThrowOnError extends boolean = false>(options?: Options<PostBetaUpdateUsageData, ThrowOnError>) => (options?.client ?? client).post<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/beta/update-usage',
    ...options
});

/**
 * Changes the plan type for a user. Requires password authentication. Can target a specific user or default to current user.
 */
export const postBetaChangePlanType = <ThrowOnError extends boolean = false>(options?: Options<PostBetaChangePlanTypeData, ThrowOnError>) => (options?.client ?? client).post<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/beta/change-plan-type',
    ...options
});
